import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, computed, input, output, Signal } from '@angular/core';
import { ITableColumn } from 'src/app/models/tableColumns';
import { TableColumnsNames } from 'src/app/models/tableColumns/tableColumnsNames.enum';
import { ColumnsOrderService } from 'src/app/services/common/columnsOrder/columns-order.service';

@Component({
  selector: 'app-columns-selection',
  templateUrl: './columns-selection.component.html',
  styleUrls: ['./columns-selection.component.scss'],
})
export class ColumnsSelectionComponent {
  public columns = input.required<ITableColumn[]>();
  public pageName = input.required<TableColumnsNames>();

  public columnsSelected = output<ITableColumn[]>();

  protected visibleColumnsIds: Signal<ITableColumn['propertyKey'][]>;

  constructor(private readonly _columnsOrderService: ColumnsOrderService) {
    this.visibleColumnsIds = computed(() =>
      this.columns()
        .filter(({ hidden }) => !hidden)
        .map(({ propertyKey }) => propertyKey)
    );
  }

  public onSelect(selectedColumn: ITableColumn): void {
    const columns = this.columns();
    columns.forEach((column) => {
      if (column === selectedColumn) {
        column.hidden = !column.hidden;
      }
    });
    this.columnsSelected.emit(columns);
    this._columnsOrderService.saveColumnsOrderToLocalStorage(this.pageName(), columns);
  }

  public selectAll(): void {
    const columns = this.columns();
    columns.forEach((column) => (column.hidden = false));
    this.columnsSelected.emit(columns);
    this._columnsOrderService.saveColumnsOrderToLocalStorage(this.pageName(), columns);
  }

  public drop(event: CdkDragDrop<string[]>) {
    const columns = this.columns();
    moveItemInArray(columns, event.previousIndex, event.currentIndex);
    this.columnsSelected.emit(columns);
    this._columnsOrderService.saveColumnsOrderToLocalStorage(this.pageName(), columns);
  }
}
